import { Col, Row, Typography } from 'antd';
import React from 'react';
import { Card } from '@common/components';
import { capitalizeFirstLetter } from '@common/services';

const { Text } = Typography;

export const DisputesCard = ({
  disputesCountByState,
}: {
  disputesCountByState: [
    {
      state: string;
      count: number;
    },
  ];
}) => {
  const disputeStateList = [
    'open',
    'reopened',
    'retracted',
    'rejected',
    'approved',
    'resolved',
    'archived',
  ];

  return (
    <>
      <Card title="Disputes" className="disputes-card">
        <Row
          gutter={[24, 0]}
          justify="space-around"
          style={{ marginRight: 12, marginLeft: 12 }}
        >
          {disputeStateList.map((state, index) => (
            <Col key={index}>
              <Row className="disputes-state-title">
                {capitalizeFirstLetter(state)}
              </Row>
              <Row justify="center">
                <Text strong>
                  {disputesCountByState.find(
                    (disputeCount: { state: string; count: number }) =>
                      disputeCount.state === state
                  )?.count || 0}
                </Text>
              </Row>
            </Col>
          ))}
        </Row>
      </Card>
      <style jsx>{`
        :global(.disputes-state-title) {
          margin-bottom: 4px;
        }
      `}</style>
    </>
  );
};
